import '@widesk-ui/components/styles/OneLineSkeleton.scss';
import AntdSkeleton from 'antd/lib/skeleton';
import View         from '@widesk-ui/components/View';
import React        from 'react';

type OneLineSkeletonProps = {
	width?: React.CSSProperties['minWidth'];
};

export default function OneLineSkeleton(props: OneLineSkeletonProps) {
	const {
		width = 80,
	} = props;

	return (
		<View row className="widesk-one-line-skeleton" heightF centerV minWidth={width} inline>
			&nbsp;<AntdSkeleton active paragraph={false} />&nbsp;
		</View>
	);
}
